import { h } from 'preact';
import { useEffect, useRef } from 'preact/hooks';
import { waitForElement } from '../utils/waitForElement';
import { useProduct } from './product-context';

const ShopPay = () => {
  const { activeVariant, allProducts } = useProduct();
  if (!allProducts) return null;

  const ref = useRef(null);

  // Update the 'original' element with the current variant ID
  // Display the 'cloned' version to the user
  useEffect(() => {
    const findElements = setTimeout(async () => {
      const element = await waitForElement('shopify-payment-terms');
      element.setAttribute('variant-id', activeVariant.id);
      const cloned = element.cloneNode(true);

      ref.current.append(cloned);
    }, 300);
    return () => clearTimeout(findElements);
  }, []);

  return null;
  // return (
  //   <div className="text-center min-h-[45px]">
  //     <div ref={ref} class={'shopify-payment-terms pt-2 text-xs'} />
  //   </div>
  // );
};

export default ShopPay;
